// components/Admin/Login.js
import React, { useState, useEffect } from "react";
import AdminPanel from "./AdminPanel";
import axios from "axios";
import { url } from "../Api/config";

const Login = () => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  // При рендере подставляем пароль из localStorage (если есть)
  useEffect(() => {
    const savedPassword = localStorage.getItem("admin_password");
    if (savedPassword) {
      setPassword(savedPassword);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${url}/api/admin/login`, { password });
      if (res.data && res.data.success) {
        setAuthenticated(true);
        // сохраняем пароль в localStorage
        localStorage.setItem("admin_password", password);
      } else {
        alert("Неверный пароль");
      }
    } catch (err) {
      console.error("Ошибка при авторизации:", err);
      alert("Ошибка соединения с сервером");
    }
  };

  if (authenticated) return <AdminPanel />;

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "300px",
        margin: "100px auto",
        gap: "10px",
      }}
    >
      <h2>Админ-панель</h2>
      <input
        type="password"
        placeholder="Введите пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ padding: "8px", fontSize: "16px" }}
      />
      <button
        type="submit"
        style={{
          padding: "8px",
          fontSize: "16px",
          background: "#007BFF",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Войти
      </button>
    </form>
  );
};

export default Login;
